<div
  id="parentIdOfHtml"
  class="d-flex align-items-center navbar-width p-menubar"
>
  <a class="navbar-brand d-flex align-items-center me-5 text-white"
    ><img
      src="assets/images/ey-logo.svg"
      width="28"
      height="28"
      (click)="goToLanding()"
      alt="Ey logo, lands to digital tax advisor page"
    />
    <span class="size pointer" [routerLink]="['/']" >EY Global Tax E-invoicing Solution</span>
    <span class="size seconday-heading ms-2">| e-Invoice Request Portal</span>
  </a>
  <div class="d-flex justify-content-end ms-auto border-0 langnav">
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <button #en class="nav-link active" data-bs-toggle="tab" type="button" role="button" (click)="changeLanguage('EN', $event)">
          EN
        </button>
      </li>
      <li class="nav-item" [ngClass]="{ 'ey-link-shatter': hideLangSign }" >
        <button #bm class="nav-link" [ngClass]="{ 'ey-link-shatter': hideLangSign }" data-bs-toggle="tab" [disabled]="hideLangSign" type="button" role="button" (click)="changeLanguage('BM', $event)">
          BM
        </button>
      </li>
    </ul>
  </div>
</div>
